/**
 * tooltip.js 
 * 
 * Opt-In to init Boostrap tooltips
 * 
 * @version   1.0.0
 * @author    Erwin Müller Versandhaus GmbH
 */
$(function () {
  $('[data-toggle="tooltip"]').tooltip();
})